import Vue from 'vue'
import consts from '@/consts'
import { createActionHelpers } from 'vuex-loading'
import i18n from '@/translator'

const { startLoading, endLoading } = createActionHelpers({
  moduleName: 'loading'
})

function getPlaylists (genreFilter, page, commit, textToFilter) {
  const promise = Vue.http.get(consts.API_BASE_URL + `/playlists/ByGenre/${genreFilter}/${page}/${textToFilter}`)
  promise.then((response) => {
    if (response.data.status === 'ok') {
      commit('incrementFrom', 1)
    }
  })
  return promise
}
function getRecommendedPlaylists (genreFilter, page, commit, textToFilter, recommended) {
  const promise = Vue.http.get(consts.API_BASE_URL + `/playlists/ByGenre/${genreFilter}/${page}/${textToFilter}/${recommended}`)
  promise.then((response) => {
    if (response.data.status === 'ok') {
      commit('incrementFrom', 1)
    }
  })
  return promise
}

const initialStates = function () {
  return {
    error: '',
    newPlaylistId: null,
    playlists: [],
    page: 0,
    recommendedPlaylists: [],
    pageRecommended: 0,
    genreFilter: 0,
    liked: false,
    isPlaylistOpen: false,
    playlist: {}
  }
}

const mutations = {
  isPlaylistOpen (state, value) {
    state.isPlaylistOpen = value
  },
  setPlaylist (state, value) {
    state.playlist = value
  },
  error (state, value) {
    state.error = value
  },
  newPlaylistId (state, value) {
    state.newPlaylistId = value
  },
  setPlaylistFrom (state, value) {
    state.page = value
  },
  setPlaylistRecommendedFrom (state, value) {
    state.pageRecommended = value
  },
  appendPage (state, value) {
    state.playlists.push(...value)
    state.page++
  },
  appendPageRecommended (state, value) {
    state.recommendedPlaylists.push(...value)
    state.pageRecommended++
  },
  setAll (state, value) {
    state.playlists = value
  },
  setAllrecommended (state, value) {
    state.recommendedPlaylists = value
  },
  setPlaylistGenreFilter (state, value) {
    state.genreFilter = value
  },
  togglePlaylistLike (state, value) {
    state.liked = value
    if (state.playlist.hasOwnProperty('liked')) {
      state.playlist.liked = value
    }
  }
}

const actions = {
  openPlaylist ({ commit }) {
    commit('isPlaylistOpen', true)
  },

  closePlaylist ({ commit }) {
    commit('isPlaylistOpen', false)
  },

  addToPlaylist ({commit, dispatch}, value) {
    startLoading(dispatch, 'playlist addToPlaylist')
    return new Promise((resolve, reject) => {
      Vue.http.post(consts.API_BASE_URL + '/playlists/setTrackInPlaylist', {
        id_playlist: value.playlistId,
        id_track: value.trackId
      }).then(
        function (response) {
          endLoading(dispatch, 'playlist addToPlaylist')
          if (response.body.status === 'ok') {
            resolve()
          } else {
            if (response.body.error === 'track already added to playlist') {
              commit('error', {error: true, message: i18n.t('playlists.trackAlreadyExist')})
              reject(new Error(i18n.t('playlists.trackAlreadyExist')))
            } else {
              commit('error', {error: true, message: i18n.t('error.store.addToPlaylist')})
              reject(new Error(i18n.t('error.store.addToPlaylist')))
            }
          }
        },
        function () {
          endLoading(dispatch, 'playlist addToPlaylist')
          commit('error', {error: true, message: i18n.t('error.store.network')})
          reject(new Error(i18n.t('error.store.network')))
        })
    })
  },

  setPlaylist ({commit, dispatch}, value) {
    startLoading(dispatch, 'playlist setPlaylist')
    return new Promise((resolve, reject) => {
      Vue.http.post(consts.API_BASE_URL + '/playlists/setPlaylist', {
        picture: value.picture,
        title: value.title,
        type: value.type
      }).then(
        function (response) {
          endLoading(dispatch, 'playlist setPlaylist')
          if (response.body.status === 'ok' && response.body.data.msg === 'saved') {
            commit('newPlaylistId', response.body.data.id_playlist)
            resolve()
          } else {
            commit('error', {error: true, message: i18n.t('error.store.newPlaylist')})
            reject(new Error(i18n.t('error.store.newPlaylist')))
          }
        },
        function () {
          endLoading(dispatch, 'playlist setPlaylist')
          commit('error', {error: true, message: i18n.t('error.store.network')})
          reject(new Error(i18n.t('error.store.network')))
        })
    })
  },

  setPlaylistAndTrack ({commit, dispatch}, value) {
    startLoading(dispatch, 'playlist setPlaylistAndTrack')
    return new Promise((resolve, reject) => {
      Vue.http.post(consts.API_BASE_URL + '/playlists/setNewPlaylistAndTrack', {
        picture: value.picture,
        title: value.title,
        type: value.type,
        track_id: value.trackId
      }).then(
        function (response) {
          endLoading(dispatch, 'playlist setPlaylistAndTrack')
          if (response.body.status === 'ok' && response.body.data.msg === 'saved') {
            commit('newPlaylistId', response.body.data.id_playlist)
            resolve()
          } else {
            commit('error', {error: true, message: i18n.t('error.store.newPlaylist')})
            reject(new Error(i18n.t('error.store.newPlaylist')))
          }
        },
        function () {
          endLoading(dispatch, 'playlist setPlaylistAndTrack')
          commit('error', {error: true, message: i18n.t('error.store.network')})
          reject(new Error(i18n.t('error.store.network')))
        })
    })
  },

  delete ({commit, dispatch}, value) {
    startLoading(dispatch, 'playlist delete')
    return new Promise((resolve, reject) => {
      Vue.http.post(consts.API_BASE_URL + '/playlists/del', {
        playlist_id: value
      }).then(
        function (response) {
          if (response.body.status === 'ok' && response.body.data === 'deleted') {
            dispatch('user/getMyPlaylists', null, {root: true})
            endLoading(dispatch, 'playlist delete')
            resolve()
          } else {
            commit('error', {error: true, message: i18n.t('error.store.deletePlaylist')})
            reject(new Error(i18n.t('error.store.deletePlaylist')))
          }
        },
        function () {
          endLoading(dispatch, 'playlist delete')
          commit('error', {error: true, message: i18n.t('error.store.network')})
          reject(new Error(i18n.t('error.store.network')))
        })
    })
  },

  edit ({commit, dispatch}, value) {
    let picture = value.picture.split(/\/uploads\/playlists\//gi).reverse()[0]
    startLoading(dispatch, 'playlist edit')
    return new Promise((resolve, reject) => {
      Vue.http.post(consts.API_BASE_URL + '/playlists/edit/' + value.playlistId, {
        title: value.title,
        picture: picture,
        type: value.type
      }).then(
        function (response) {
          if (response.body.status === 'ok' && response.body.data.msg === 'saved') {
            dispatch('user/getMyPlaylists', null, {root: true})
            endLoading(dispatch, 'playlist edit')
            resolve()
          } else {
            endLoading(dispatch, 'playlist edit')
            commit('error', {error: true, message: i18n.t('error.store.updatePlaylist')})
            reject(new Error(i18n.t('error.store.updatePlaylist')))
          }
        },
        function () {
          endLoading(dispatch, 'playlist edit')
          commit('error', {error: true, message: i18n.t('error.store.network')})
          reject(new Error(i18n.t('error.store.network')))
        })
    })
  },

  getFeaturedPlaylist ({dispatch, commit}) {
    startLoading(dispatch, 'playlist getFeaturedPlaylist')
    return Vue.http.get(consts.API_BASE_URL + '/featured_playlists/getLast')
      .then((response) => {
        endLoading(dispatch, 'playlist getFeaturedPlaylist')
        if (response.body.status) {
          return Promise.resolve(response.body.data)
        } else {
          switch (response.body.error.message) {
            case 'no artist found': {
              commit('error', {
                message: i18n.t('error.store.noArtistFound')
              })
              break
            }
            default: {
              commit('error', {
                message: i18n.t('error.store.featuredPlaylist')
              })
              break
            }
          }
          return Promise.reject(new Error(response.body.error.message))
        }
      }).catch((e) => {
        endLoading(dispatch, 'playlist getFeaturedPlaylist')
        return Promise.reject(new Error(i18n.t('error.store.network')))
      })
  },

  deleteTrackFromPlaylist ({commit, dispatch}, value) {
    startLoading(dispatch, 'playlist deleteTrack')
    return Vue.http.post(consts.API_BASE_URL + '/playlists/deleteTrackFromPlaylist', {
      id_track: value.trackId,
      id_playlist: value.playlistId
    }).then((response) => {
      if (response.body.status === 'ok' && response.body.data === 'deleted') {
        dispatch('user/getMyPlaylists', null, {root: true})
        Vue.http.get(consts.API_BASE_URL + '/playlists/getPlaylist/' + value.playlistId)
          .then((response) => {
            endLoading(dispatch, 'playlist getPlaylist')
            if (response.body.status) {
              commit('setPlaylist', response.body.data)
              return Promise.resolve(response.body.data)
            } else {
              return Promise.reject(new Error(response.body.error))
            }
          })
        endLoading(dispatch, 'playlist delete')
        return Promise.resolve()
      } else {
        endLoading(dispatch, 'playlist delete')
        return Promise.reject(new Error(i18n.t('error.store.deleteFromPlaylist')))
      }
    }).catch(() => {
      endLoading(dispatch, 'playlist delete')
      return Promise.reject(new Error(i18n.t('error.store.network')))
    })
  },

  getPlaylist ({commit, dispatch}, id) {
    startLoading(dispatch, 'playlist getPlaylist')
    commit('setPlaylist', {})
    return Vue.http.get(consts.API_BASE_URL + '/playlists/getPlaylist/' + id)
      .then((response) => {
        endLoading(dispatch, 'playlist getPlaylist')
        if (response.body.status) {
          commit('setPlaylist', response.body.data)
          return Promise.resolve(response.body.data)
        } else {
          return Promise.reject(new Error(response.body.error))
        }
      }).catch((e) => {
        endLoading(dispatch, 'playlist getPlaylist')
        if (e.body.error) {
          switch (e.body.error.message) {
            case 'Playlist no encontrada': {
              commit('error', {
                message: i18n.t('error.store.playlistNotFound')
              })
              break
            }
            case 'Playlist privada': {
              commit('error', {
                message: i18n.t('error.store.privatePlaylist')
              })
              break
            }
            default: {
              commit('error', {
                message: i18n.t('error.store.getPlaylist'),
                input: ''
              })
            }
          }
          return Promise.reject(new Error(e.body.error.message))
        }
        return Promise.reject(new Error(i18n.t('error.store.network')))
      })
  },

  resetError ({commit, state}) {
    commit('error', '')
  },

  setPlaylistFrom ({ commit }, value) {
    commit('setPlaylistFrom', value)
  },

  setPlaylistRecommendedFrom ({ commit }, value) {
    commit('setPlaylistRecommendedFrom', value)
  },

  setPlaylistGenreFilter ({commit}, value) {
    commit('setPlaylistGenreFilter', value)
  },

  loadMorePlaylist ({ commit, state, dispatch }, textToFilter) {
    startLoading(dispatch, 'playlist loadMore')
    return new Promise((resolve, reject) => {
      getPlaylists(state.genreFilter, state.page, commit, textToFilter)
        .then(
          function (response) {
            commit('previousRequest', false)
            if (response.status === 200) {
              if (response.body.data.length > 0) {
                commit('appendPage', response.body.data)
              } else {
                // commit('noMoreResults')
              }
              endLoading(dispatch, 'playlist loadMore')
              resolve(response.body.data)
            } else {
              commit('error', { error: true, message: i18n.t('error.store.playlist') })
              endLoading(dispatch, 'playlist loadMore')
              reject(new Error(i18n.t('error.store.playlist')))
            }
          },
          function () {
            commit('previousRequest', false)
            endLoading(dispatch, 'playlist loadMore')
            commit('error', { error: true, message: i18n.t('error.store.network') })
            reject(new Error(i18n.t('error.store.network')))
          }
        )
    })
  },

  loadMoreRecommendedPlaylist ({ commit, state, dispatch }, textToFilter) {
    startLoading(dispatch, 'recommendedPlaylist loadMore')
    return new Promise((resolve, reject) => {
      getRecommendedPlaylists(state.genreFilter, state.page, commit, textToFilter, true)
        .then(
          function (response) {
            commit('previousRequest', false)
            if (response.status === 200) {
              if (response.body.data.length > 0) {
                commit('appendPageRecommended', response.body.data)
              } else {
                // commit('noMoreResults')
              }
              endLoading(dispatch, 'recommendedPlaylist loadMore')
              resolve(response.body.data)
            } else {
              commit('error', { error: true, message: i18n.t('error.store.playlist') })
              endLoading(dispatch, 'recommendedPlaylist loadMore')
              reject(new Error(i18n.t('error.store.playlist')))
            }
          },
          function () {
            commit('previousRequest', false)
            endLoading(dispatch, 'recommendedPlaylist loadMore')
            commit('error', { error: true, message: i18n.t('error.store.network') })
            reject(new Error(i18n.t('error.store.network')))
          }
        )
    })
  },

  getAllPlaylist ({commit, dispatch, state}, textToFilter = null) {
    startLoading(dispatch, 'playlist getAll')
    // commit('noMoreResults', false)
    return new Promise((resolve, reject) => {
      getPlaylists(state.genreFilter, state.page, commit, textToFilter)
        .then(
          function (response) {
            endLoading(dispatch, 'playlist getAll')
            if (response.body.status === true) {
              commit('setAll', response.body.data)
              commit('setPlaylistFrom', 1)
              resolve(response.body.data)
            } else {
              commit('setAll', response.body.data)
              commit('error', {error: true, message: i18n.t('error.store.playlist')})
              reject(new Error(i18n.t('error.store.network')))
            }
          },
          function () {
            endLoading(dispatch, 'playlist getAll')
            commit('error', {error: true, message: i18n.t('error.store.network')})
            reject(new Error(i18n.t('error.store.network')))
          }
        )
    })
  },

  getAllRecommendedPlaylist ({commit, dispatch, state}, textToFilter = null) {
    startLoading(dispatch, 'playlist getAllRecommendedPlaylist')
    // commit('noMoreResults', false)
    return new Promise((resolve, reject) => {
      getRecommendedPlaylists(state.genreFilter, state.page, commit, textToFilter, true)
        .then(
          function (response) {
            endLoading(dispatch, 'playlist getAllRecommendedPlaylist')
            if (response.body.status === true) {
              commit('setAllrecommended', response.body.data)
              commit('setPlaylistRecommendedFrom', 1)
              resolve(response.body.data)
            } else {
              commit('setAllrecommended', response.body.data)
              commit('error', {error: true, message: i18n.t('error.store.playlist')})
              reject(new Error(i18n.t('error.store.network')))
            }
          },
          function () {
            endLoading(dispatch, 'playlist getAllRecommendedPlaylist')
            commit('error', {error: true, message: i18n.t('error.store.network')})
            reject(new Error(i18n.t('error.store.network')))
          }
        )
    })
  },

  togglePlaylistLike ({commit, dispatch}, value) {
    startLoading(dispatch, 'playlist like')
    return new Promise((resolve, reject) => {
      Vue.http.post(consts.API_BASE_URL + '/playlists/like', {
        id_playlist: value
      }).then(
        function (response) {
          endLoading(dispatch, 'playlist like')
          if (response.body.like === true || response.body.like === false) {
            commit('togglePlaylistLike', response.body.like)
            resolve()
          } else {
            commit('error', {error: true, message: i18n.t('error.store.likePlaylist')})
            reject(new Error(i18n.t('error.store.likePlaylist')))
          }
        })
    })
  }

}

const getters = {
  error: state => {
    return state.error
  },
  newPlaylistId: state => {
    return state.newPlaylistId
  },
  genreFilter: state => {
    return state.genreFilter
  },
  playlists: state => {
    return state.playlists
  },
  playlist: state => {
    return state.playlist
  },
  recommendedPlaylists: state => {
    return state.recommendedPlaylists
  },
  playlistLiked: state => {
    return state.liked
  },
  isPlaylistOpen: state => {
    return state.isPlaylistOpen
  }
}

const playlist = {
  namespaced: true,
  initialStates,
  state: initialStates(),
  mutations: mutations,
  actions: actions,
  getters: getters
}

export default playlist



// WEBPACK FOOTER //
// ./src/store/modules/playlist.js